import {getResource} from "./common"

export type PaymentAuthorizationRuleDocumentUrl = {
	id: string
	type: "paymentAuthorizationRuleDocumentUrl"
	attributes: {
		url: string
	}
}

export async function getPaymentAuthorizationRuleDocumentUrl(accessToken: string, id: string) {
	return await getResource<PaymentAuthorizationRuleDocumentUrl>(
		`payment-authorization-rules/${id}/document`,
		accessToken
	)
}
